import { type QueryHookOptions, useQuery } from "@apollo/client";
import {
  EmailTemplatePreviewQuery,
  EmailTemplateQuery,
  EmailTemplatesListQuery,
} from "../graphql/queries";
import type {
  EmailTemplatePreviewQueryType,
  EmailTemplatePreviewQueryVariablesType,
  EmailTemplateQueryType,
  EmailTemplateQueryVariablesType,
  EmailTemplatesListQueryType,
  EmailTemplatesListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useEmailTemplatesListQuery = (
  options?: QueryHookOptions<
    EmailTemplatesListQueryType,
    EmailTemplatesListQueryVariablesType
  >
) =>
  useQuery<EmailTemplatesListQueryType, EmailTemplatesListQueryVariablesType>(
    EmailTemplatesListQuery,
    options
  );

export const useEmailTemplateQuery = (
  options?: QueryHookOptions<
    EmailTemplateQueryType,
    EmailTemplateQueryVariablesType
  >
) =>
  useQuery<EmailTemplateQueryType, EmailTemplateQueryVariablesType>(
    EmailTemplateQuery,
    options
  );

/**
 * Живое превью несохранённого варианта письма (Task 10): вызывающий сам
 * управляет `skip`/`variables` (черновик блоков меняется на каждый ввод).
 */
export const useEmailTemplatePreviewQuery = (
  options?: QueryHookOptions<
    EmailTemplatePreviewQueryType,
    EmailTemplatePreviewQueryVariablesType
  >
) =>
  useQuery<
    EmailTemplatePreviewQueryType,
    EmailTemplatePreviewQueryVariablesType
  >(EmailTemplatePreviewQuery, options);
